/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Navigate } from "react-router";
import ColorStyleguide from "@/src/styleguide/ColorStyleguide/ColorStyleguide.tsx";
import ButtonStyleguide from "@/src/styleguide/ButtonStyleguide.tsx";
import TypographyStyleguide from "@/src/styleguide/TypographyStyleguide.tsx";
import ChipStyleguide from "@/src/styleguide/ChipStyleguide.tsx";
import TagStyleguide from "@/src/styleguide/TagStyleguide.tsx";
import LinkStyleguide from "@/src/styleguide/LinkStyleguide.tsx";
import PaperStyleguide from "@/src/styleguide/PaperStyleguide.tsx";
import AnimationStyleguide from "@/src/styleguide/AnimationStyleguide.tsx";
import Styleguide from "@/src/styleguide/components/Styleguide/Styleguide.tsx";
import ToastStyleguide from "@/src/styleguide/ToastStyleguide.tsx";
import AlertStyleguide from "@/src/styleguide/AlertStyleguide.tsx";
import DialogStyleguide from "@/src/styleguide/DialogStyleguide.tsx";
import FooterStyleguide from "@/src/styleguide/FooterStyleguide.tsx";
import IconStyleguide from "@/src/styleguide/IconStyleguide.tsx";
import AccordionStyleguide from "@/src/styleguide/AccordionStyleguide.tsx";
import ContainerStyleguide from "@/src/styleguide/ContainerStyleguide";
import ServiceworldHeroStyleguide from "@/src/styleguide/ServiceworldHeroStyleguide";
import AreasOfLawStyleguide from "@/src/styleguide/AreasOfLawStyleguide";
import OurServiceStyleguide from "@/src/styleguide/OurServiceStyleguide";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";

export default function StyleguidePage() {
  if (import.meta.env.VITE_DEPLOYMENT === "production") {
    return <Navigate to={"/"} />;
  }

  return (
    <Styleguide
      sections={[
        {
          title: "General",
          id: "general",
          subSections: [
            {
              title: "Typography",
              id: "typography",
              children: <TypographyStyleguide />,
            },
            {
              title: "Colors",
              id: "colors",
              children: <ColorStyleguide />,
            },
            {
              title: "Icons",
              id: "icons",
              children: <IconStyleguide />,
            },
          ],
        },
        {
          title: "General Full Width",
          id: "general-full-width",
          fullWidth: true,
          subSections: [
            {
              title: "Containers",
              id: "containers",
              fullWidth: true,
              children: <ContainerStyleguide />,
            },
          ],
        },
        {
          title: "Components",
          id: "components",
          subSections: [
            {
              title: "Buttons",
              id: "buttons",
              children: <ButtonStyleguide />,
            },
            {
              title: "Links",
              id: "links",
              children: <LinkStyleguide />,
            },
            {
              title: "Chips",
              id: "chips",
              children: <ChipStyleguide />,
            },
            {
              title: "Tags",
              id: "tags",
              children: <TagStyleguide />,
            },
            {
              title: "Papers",
              id: "papers",
              children: <PaperStyleguide />,
            },
            {
              title: "Toast",
              id: "toast",
              children: <ToastStyleguide />,
            },
            {
              title: "Alert",
              id: "alert",
              children: <AlertStyleguide />,
            },
            {
              title: "Dialog",
              id: "dialog",
              children: <DialogStyleguide />,
            },
            {
              title: "Accordion",
              id: "accordion",
              children: <AccordionStyleguide />,
            },
          ],
        },
        {
          title: "Animation",
          id: "animations",
          subSections: AnimationStyleguide,
        },
        {
          title: "Modules",
          id: "modules",
          fullWidth: true,
          subSections: [
            {
              title: "Serviceworld Hero",
              id: "serviceworld-hero",
              children: <ServiceworldHeroStyleguide />,
              fullWidth: true,
            },
            {
              title: "Areas of law",
              id: "areas-of-law",
              children: <AreasOfLawStyleguide />,
              fullWidth: true,
            },
            {
              title: "Customer Feedback",
              id: "customer-feedback",
              children: <CustomerFeedback />,
              fullWidth: true,
            },
            {
              title: "Our Service",
              id: "our-service",
              children: <OurServiceStyleguide />,
              fullWidth: true,
            },
            {
              title: "Footer",
              id: "footer",
              children: <FooterStyleguide />,
              fullWidth: true,
            },
          ],
        },
      ]}
    />
  );
}
